export const projectsTranslations = {
  ru: {
    links: {
      goToService: "Перейти на Сервис",
      site1: "Сайт 1",
      site2: "Сайт 2",
      site3: "Сайт 3",
      demo: "Демо",
      github: "GitHub"
    }
  },
  en: {
    links: {
      goToService: "Go to Service",
      site1: "Site 1",
      site2: "Site 2",
      site3: "Site 3",
      demo: "Demo",
      github: "GitHub"
    }
  }
};